import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center py-32"
}
const _hoisted_2 = {
  key: 1,
  class: "max-w-4xl mx-auto px-6 py-16 text-center"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "text-gray-500 mb-6" }
const _hoisted_5 = {
  key: 2,
  class: "max-w-6xl mx-auto px-6 py-8"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "bg-white rounded-lg border border-gray-200 p-6 mb-6" }
const _hoisted_8 = { class: "flex items-start justify-between" }
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = { class: "text-2xl font-bold text-gray-900 mb-2" }
const _hoisted_11 = { class: "flex items-center gap-4 text-sm text-gray-500" }
const _hoisted_12 = { class: "flex items-center gap-1" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "flex items-center gap-1" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 0,
  class: "mt-4 pt-4 border-t border-gray-100"
}
const _hoisted_17 = { class: "flex items-center gap-6" }
const _hoisted_18 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_19 = { class: "text-xs text-gray-500 capitalize" }
const _hoisted_20 = {
  key: 1,
  class: "mt-4 pt-4 border-t border-gray-100"
}
const _hoisted_21 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}
const _hoisted_25 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6" }
const _hoisted_26 = { class: "lg:col-span-1 space-y-6" }
const _hoisted_27 = {
  key: 0,
  class: "bg-white rounded-lg border border-gray-200 p-5"
}
const _hoisted_28 = { class: "text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "text-sm text-gray-600 leading-relaxed" }
const _hoisted_31 = {
  key: 1,
  class: "bg-white rounded-lg border border-gray-200 p-5"
}
const _hoisted_32 = { class: "text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "text-sm text-gray-600 leading-relaxed" }
const _hoisted_35 = {
  key: 2,
  class: "bg-white rounded-lg border border-gray-200 p-5"
}
const _hoisted_36 = { class: "text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "text-sm text-gray-600 leading-relaxed whitespace-pre-line" }
const _hoisted_39 = {
  key: 3,
  class: "bg-white rounded-lg border border-gray-200 p-5"
}
const _hoisted_40 = { class: "text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "flex flex-wrap gap-2" }
const _hoisted_43 = {
  key: 4,
  class: "bg-white rounded-lg border border-gray-200 p-5"
}
const _hoisted_44 = { class: "text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "space-y-2" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "flex items-center justify-between" }
const _hoisted_49 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_50 = { class: "text-xs text-gray-400" }
const _hoisted_51 = {
  key: 0,
  class: "text-xs text-gray-500 mt-1 line-clamp-2"
}
const _hoisted_52 = { class: "lg:col-span-2" }
const _hoisted_53 = { class: "bg-white rounded-lg border border-gray-200 p-5" }
const _hoisted_54 = { class: "text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2" }
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = {
  key: 0,
  class: "space-y-4 max-h-[600px] overflow-y-auto pr-2"
}
const _hoisted_57 = ["id", "data-start-time", "onClick"]
const _hoisted_58 = { class: "flex-1" }
const _hoisted_59 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_60 = { class: "text-xs font-medium text-gray-700 capitalize" }
const _hoisted_61 = ["onClick", "title"]
const _hoisted_62 = {
  key: 1,
  class: "text-xs text-gray-400"
}
const _hoisted_63 = {
  key: 1,
  class: "max-h-[600px] overflow-y-auto"
}
const _hoisted_64 = { class: "text-sm text-gray-600 leading-relaxed whitespace-pre-wrap" }
const _hoisted_65 = {
  key: 2,
  class: "text-center py-12 text-gray-400"
}
const _hoisted_66 = {
  key: 3,
  class: "max-w-4xl mx-auto px-6 py-16 text-center"
}
const _hoisted_67 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary-purple" }, null, -1)
        ]))]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              innerHTML: _ctx.ERROR_ICON,
              class: "mx-auto mb-4 text-red-400"
            }, null, 8, _hoisted_3),
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-900 mb-2" }, " Unable to load transcript ", -1)),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.error), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
              class: "px-4 py-2 bg-primary-purple text-white rounded-lg hover:bg-primary-purple/90"
            }, " Go Back ")
          ]))
        : (_ctx.transcript)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 mb-6"
              }, [
                _createElementVNode("span", { innerHTML: _ctx.ARROW_LEFT_ICON }, null, 8, _hoisted_6),
                _cache[6] || (_cache[6] = _createTextVNode(" Back to Search ", -1))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.transcript.callTitle || "Call Transcript"), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.CALENDAR_ICON,
                          class: "w-4 h-4"
                        }, null, 8, _hoisted_13),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.transcript.processedAt)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_14, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.CLOCK_ICON,
                          class: "w-4 h-4"
                        }, null, 8, _hoisted_15),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDuration(_ctx.transcript.durationSeconds)), 1)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-2.5 py-0.5 text-xs font-medium rounded-full", _ctx.getStatusClass(_ctx.transcript.processingStatus)])
                      }, _toDisplayString(_ctx.formatStatus(_ctx.transcript.processingStatus)), 3)
                    ])
                  ])
                ]),
                (_ctx.transcript.speakers && _ctx.transcript.speakers.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcript.speakers, (speaker) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: speaker.role,
                            class: "flex items-center gap-2"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium", 
                  speaker.role === 'expert'
                    ? 'bg-primary-purple'
                    : 'bg-blue-500'
                ])
                            }, _toDisplayString(_ctx.getInitials(speaker.name)), 3),
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_18, _toDisplayString(speaker.name || "Unknown"), 1),
                              _createElementVNode("p", _hoisted_19, _toDisplayString(speaker.role), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.transcript.audioUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.AUDIO_ICON,
                          class: "w-4 h-4 text-primary-purple"
                        }, null, 8, _hoisted_22),
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Recording", -1))
                      ]),
                      _createElementVNode("audio", {
                        ref: "audioPlayer",
                        src: _ctx.transcript.audioUrl,
                        controls: "",
                        preload: "metadata",
                        class: "w-full h-10 rounded-lg",
                        onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleAudioError && _ctx.handleAudioError(...args)))
                      }, " Your browser does not support the audio element. ", 40, _hoisted_23),
                      (_ctx.audioError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.audioError), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.transcript.callBrief)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("h3", _hoisted_28, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.SUMMARY_ICON,
                            class: "w-4 h-4 text-primary-purple"
                          }, null, 8, _hoisted_29),
                          _cache[8] || (_cache[8] = _createTextVNode(" Summary ", -1))
                        ]),
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.transcript.callBrief), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.transcript.callContext)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("h3", _hoisted_32, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.INFO_ICON,
                            class: "w-4 h-4 text-blue-500"
                          }, null, 8, _hoisted_33),
                          _cache[9] || (_cache[9] = _createTextVNode(" Context ", -1))
                        ]),
                        _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.transcript.callContext), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.transcript.nextSteps)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("h3", _hoisted_36, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.CHECKLIST_ICON,
                            class: "w-4 h-4 text-green-500"
                          }, null, 8, _hoisted_37),
                          _cache[10] || (_cache[10] = _createTextVNode(" Next Steps ", -1))
                        ]),
                        _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.transcript.nextSteps), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.transcript.keyTopics && _ctx.transcript.keyTopics.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("h3", _hoisted_40, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.TAG_ICON,
                            class: "w-4 h-4 text-purple-500"
                          }, null, 8, _hoisted_41),
                          _cache[11] || (_cache[11] = _createTextVNode(" Topics Discussed ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcript.keyTopics, (topic) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: topic,
                              class: "px-2.5 py-1 text-xs font-medium bg-purple-50 text-purple-700 rounded-full"
                            }, _toDisplayString(topic), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.transcript.chapters && _ctx.transcript.chapters.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("h3", _hoisted_44, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.CHAPTERS_ICON,
                            class: "w-4 h-4 text-orange-500"
                          }, null, 8, _hoisted_45),
                          _cache[12] || (_cache[12] = _createTextVNode(" Chapters ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcript.chapters, (chapter, index) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: index,
                              onClick: ($event: any) => (_ctx.scrollToTime(chapter.startTime)),
                              class: "w-full text-left p-3 rounded-lg hover:bg-gray-50 transition-colors border border-gray-100"
                            }, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("span", _hoisted_49, _toDisplayString(chapter.title), 1),
                                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.formatTime(chapter.startTime)), 1)
                              ]),
                              (chapter.description)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(chapter.description), 1))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_47))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("h3", _hoisted_54, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.TRANSCRIPT_ICON,
                        class: "w-4 h-4 text-gray-500"
                      }, null, 8, _hoisted_55),
                      _cache[13] || (_cache[13] = _createTextVNode(" Transcript ", -1))
                    ]),
                    (_ctx.transcript.segments && _ctx.transcript.segments.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcript.segments, (segment, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              id: `segment-${index}`,
                              "data-start-time": segment.startTime,
                              class: _normalizeClass(["flex gap-3 group", { 'cursor-pointer': _ctx.transcript.audioUrl }]),
                              onClick: ($event: any) => (_ctx.transcript.audioUrl && _ctx.seekToSegment(segment.startTime))
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-medium flex-shrink-0", 
                    segment.speaker === 'expert'
                      ? 'bg-primary-purple'
                      : 'bg-blue-500'
                  ])
                              }, _toDisplayString(_ctx.getSpeakerInitials(segment.speaker)), 3),
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.getSpeakerName(segment.speaker)), 1),
                                  (_ctx.transcript.audioUrl)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: _withModifiers(($event: any) => (_ctx.seekToSegment(segment.startTime)), ["stop"]),
                                        class: "text-xs text-gray-400 hover:text-primary-purple transition-colors",
                                        title: `Play from ${_ctx.formatTime(segment.startTime)}`
                                      }, _toDisplayString(_ctx.formatTime(segment.startTime)), 9, _hoisted_61))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.formatTime(segment.startTime)), 1))
                                ]),
                                _createElementVNode("p", {
                                  class: _normalizeClass(["text-sm text-gray-600 leading-relaxed p-3 rounded-lg transition-colors", [
                      segment.speaker === 'expert'
                        ? 'bg-purple-50'
                        : 'bg-blue-50',
                      _ctx.transcript.audioUrl
                        ? 'group-hover:ring-2 group-hover:ring-primary-purple/20'
                        : '',
                    ]])
                                }, _toDisplayString(segment.text), 3)
                              ])
                            ], 10, _hoisted_57))
                          }), 128))
                        ]))
                      : (_ctx.transcript.fullTranscript)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.transcript.fullTranscript), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_65, [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("p", null, "No transcript content available", -1)
                          ]))]))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _createElementVNode("div", {
                innerHTML: _ctx.NOT_FOUND_ICON,
                class: "mx-auto mb-4 text-gray-300"
              }, null, 8, _hoisted_67),
              _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-900 mb-2" }, " Transcript not found ", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-gray-500 mb-6" }, " The transcript you're looking for doesn't exist or you don't have access. ", -1)),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "px-4 py-2 bg-primary-purple text-white rounded-lg hover:bg-primary-purple/90"
              }, " Go Back ")
            ]))
  ]))
}